<template>
  <div class="survey-form">
    <div class="survey-form-box" v-if="formListData.length > 0">
      <van-form ref="vanForm" label-width="auto">
        <div
          v-for="(item, index) in formListData"
          :key="index"
          class="form-question"
        >
          <!-- 题目标题 -->
          <div class="question-title">
            <span class="question-number">{{ index + 1 }}、</span>
            <span class="question-content">{{ item.content }}</span>
            <span v-if="item.required" class="required-mark">*</span>
            <span class="question-type-tag">{{
              getQuestionTypeLabel(item.questionType)
            }}</span>
          </div>

          <!-- 1. 单选题 -->
          <template v-if="item.questionType === 'single'">
            <van-radio-group
              v-model="formData[item.itemFormKey]"
              direction="vertical"
            >
              <van-radio
                v-for="option in item.options"
                :key="option.id"
                :name="option.optionNum"
                class="radio-item"
              >
                {{ option.content }}
              </van-radio>
            </van-radio-group>
            <van-field
              v-if="formData[item.itemFormKey] === 'OTHER'"
              v-model="formData[item.itemFormOtherKey]"
              type="textarea"
              rows="2"
              placeholder="请填写内容"
              maxlength="120"
              show-word-limit
              class="other-input"
            />
          </template>

          <!-- 2. 多选题 -->
          <template v-else-if="item.questionType === 'multiple'">
            <van-checkbox-group
              v-model="formData[item.itemFormKey]"
              direction="vertical"
              @change="multipleChange($event,item)"
            >
              <van-checkbox
                v-for="option in item.options"
                :key="option.id"
                :name="option.optionNum"
                class="checkbox-item"
              >
                {{ option.content }}
              </van-checkbox>
            </van-checkbox-group>
            <van-field
              v-if="formData[item.itemFormKey].includes('OTHER')"
              v-model="formData[item.itemFormOtherKey]"
              type="textarea"
              rows="2"
              placeholder="请填写内容"
              maxlength="120"
              show-word-limit
              class="other-input"
            />
          </template>

          <!-- 3. 问答题 -->
          <template v-else-if="item.questionType === 'essay'">
            <van-field
              v-model="formData[item.itemFormKey]"
              type="textarea"
              rows="4"
              :placeholder="item.placeholder || '请输入您的答案'"
              maxlength="500"
              show-word-limit
              class="essay-input"
            />
          </template>

          <!-- 4. 填空题 -->
          <template v-else-if="item.questionType === 'blank'">
            <van-field
              v-model="formData[item.itemFormKey]"
              type="text"
              :placeholder="item.placeholder || '请输入答案'"
              maxlength="200"
              class="blank-input"
            />
          </template>

          <!-- 5. 图片题 -->
          <template v-else-if="item.questionType === 'image'">
            <van-uploader
              v-model="formData[item.itemFormKey]"
              :max-count="item.maxImages || 3"
              :preview-options="{
                closeable: true,
              }"
              :max-size="5 * 1024 * 1024"
              :after-read="(file) => afterReadImage(file, item.itemFormKey)"
              :before-delete="
                (file) => beforeDeleteImage(file, item.itemFormKey)
              "
              @oversize="onImageOversize"
              class="image-uploader"
            >
              <!-- <template #preview-cover="{ file }">
                <div class="preview-cover">
                  <van-icon name="eye-o" @click.stop="previewImage(file)" />
                </div>
              </template> -->
            </van-uploader>
            <div class="upload-tip">
              最多上传{{ item.maxImages || 3 }}张图片，每张不超过5MB
            </div>
          </template>

          <!-- 6. 时间题 -->
          <template v-else-if="item.questionType === 'datetime'">
            <van-field
              v-model="formData[item.itemFormKey]"
              readonly
              clickable
              :placeholder="item.placeholder || '请选择时间'"
              @click="showDatetimePicker(index)"
              class="datetime-input"
            />
          </template>
        </div>
      </van-form>

      <!-- 时间选择器弹窗（统一管理） -->
      <van-popup v-model="datePickerVisible" position="bottom">
        <van-datetime-picker
          v-if="currentDatetimeQuestion"
          v-model="currentDateValue"
          :type="currentDatetimeQuestion.dateType || 'datetime'"
          :title="currentDatetimeQuestion.pickerTitle || '选择时间'"
          :min-date="currentDatetimeQuestion.minDate || minDate"
          :max-date="currentDatetimeQuestion.maxDate || maxDate"
          @confirm="confirmDatetime"
          @cancel="datePickerVisible = false"
        />
      </van-popup>

      <div class="btn-box">
        <van-button
          type="primary"
          size="large"
          color="#017A3F"
          :loading="btnLoading"
          @click="handleSubmit"
        >
          提交
        </van-button>
      </div>
    </div>
    <van-empty v-else image="error" description="问卷调查加载中..." />
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import upload from "@/api/upload";

export default {
  name: "SurveyForm",
  props: {
    formList: {
      type: Array,
      default: () => [],
    },
    surveyId: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      formData: {},
      formListData: [],
      btnLoading: false,
      // 时间选择器相关
      datePickerVisible: false,
      currentDatetimeQuestion: null,
      currentDatetimeIndex: null,
      currentDateValue: new Date(),
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2099, 11, 31),
    };
  },
  watch: {
    formList(newValue) {
      this.generateFormData(newValue);
    },
  },
  methods: {
    multipleChange(e,item){
      console.log(e.length,item)
      if(item.maxSelect){
        if(e.length>item.maxSelect){
          this.$toast(`本题最多选${item.maxSelect}项`);
          this.formData[item.itemFormKey].pop()
        }
      }
      
    },
    // 获取问题类型标签
    getQuestionTypeLabel(type) {
      const typeMap = {
        single: "单选",
        multiple: "多选",
        essay: "问答",
        blank: "填空",
        image: "图片",
        datetime: "时间",
      };
      return typeMap[type] || "";
    },

    // 生成表单数据
    generateFormData(formList = []) {
      this.formListData = formList.map((item, index) => {
        // 处理表单字段
        item.required = item.mandatory == 1 ? true : false; // 必填

        // 根据 questionsType 确定问题类型
        const typeMap = {
          1: "single", // 单选
          2: "multiple", // 多选
          3: "essay", // 问答
          4: "blank", // 填空
          5: "image", // 图片
          6: "datetime", // 时间
        };
        item.questionType = typeMap[item.questionsType] || "single";

        // 生成表单字段名
        const itemFormKey = `question_${index}`;
        const itemFormOtherKey = `question_other_${index}`;

        // 根据类型设置初始值
        switch (item.questionType) {
          case "single":
          case "blank":
          case "essay":
          case "datetime":
            this.$set(this.formData, itemFormKey, "");
            break;
          case "multiple":
          case "image":
            this.$set(this.formData, itemFormKey, []);
            break;
        }

        this.$set(this.formData, itemFormOtherKey, "");

        // 赋值字段
        item.itemFormKey = itemFormKey;
        item.itemFormOtherKey = itemFormOtherKey;

        return item;
      });
    },

    // 显示时间选择器
    showDatetimePicker(index) {
      const item = this.formListData[index];
      this.currentDatetimeQuestion = item;
      this.currentDatetimeIndex = index;

      // 如果已有值，则使用该值初始化选择器
      const currentValue = this.formData[item.itemFormKey];
      if (currentValue) {
        this.currentDateValue = this.parseDateTime(
          currentValue,
          item.dateType || "datetime"
        );
      } else {
        this.currentDateValue = new Date();
      }

      this.datePickerVisible = true;
    },

    // 解析日期时间字符串
    parseDateTime(dateStr, dateType) {
      if (!dateStr) return new Date();

      try {
        // 根据类型解析日期
        switch (dateType) {
          case "date":
            // YYYY-MM-DD
            return new Date(dateStr);
          case "time": {
            // HH:mm
            const [hour, minute] = dateStr.split(":");
            const d = new Date();
            d.setHours(parseInt(hour), parseInt(minute), 0, 0);
            return d;
          }
          case "year-month":
            // YYYY-MM
            return new Date(dateStr + "-01");
          default:
            // YYYY-MM-DD HH:mm
            return new Date(dateStr.replace(" ", "T"));
        }
      } catch (e) {
        return new Date();
      }
    },

    // 确认时间选择
    confirmDatetime() {
      const date = this.currentDateValue;
      const item = this.currentDatetimeQuestion;
      let formattedDate = "";

      switch (item.dateType) {
        case "date":
          formattedDate = this.formatDate(date, "YYYY-MM-DD");
          break;
        case "time":
          formattedDate = this.formatDate(date, "HH:mm");
          break;
        case "year-month":
          formattedDate = this.formatDate(date, "YYYY-MM");
          break;
        default:
          formattedDate = this.formatDate(date, "YYYY-MM-DD HH:mm");
      }

      this.$set(this.formData, item.itemFormKey, formattedDate);
      this.datePickerVisible = false;
    },

    // 格式化日期
    formatDate(date, format) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");

      return format
        .replace("YYYY", year)
        .replace("MM", month)
        .replace("DD", day)
        .replace("HH", hour)
        .replace("mm", minute);
    },

    // 图片上传后处理
    async afterReadImage(file) {
      if (!file.file) return;

      file.status = "uploading";
      file.message = "上传中...";

      try {
        // 调用真实的上传接口
        const response = await upload("surveyDir", file.file);
        if (response) {
          // 保存服务器返回的原始路径（用于提交）
          file.serverPath = response;

          // 拼接完整的 URL（用于预览）
          const baseUrl = process.env.VUE_APP_FILE_URL || "";
          let fullUrl = response;

          // 如果服务器返回的是相对路径，添加前缀
          if (fullUrl && !fullUrl.startsWith("http") && !fullUrl.startsWith("data:")) {
            fullUrl = baseUrl + fullUrl;
          }

          file.url = fullUrl;  // 保存完整的 URL
          file.status = "done";
          file.message = "";
        } else {
          // 上传失败
          file.status = "failed";
          file.message = "上传失败";
          this.$toast("图片上传失败：" + (response.message || "未知错误"));
        }
      } catch (error) {
        // 上传异常
        file.status = "failed";
        file.message = "上传失败";
        this.$toast("图片上传失败，请重试");
        console.error("图片上传错误：", error);
      }
    },

    // 删除图片前确认
    async beforeDeleteImage() {
      try {
        await this.$dialog.confirm({
          title: "确认删除",
          message: "确定要删除这张图片吗？",
        });
        // 用户确认删除
        return true;
      } catch {
        // 用户取消删除
        return false;
      }
    },

    // 删除图片
    deleteImage(file, itemFormKey) {
      const fileList = this.formData[itemFormKey];
      const index = fileList.findIndex((item) => item === file);
      if (index > -1) {
        fileList.splice(index, 1);
        this.$toast("图片已删除");
      }
    },

    // 预览图片
    previewImage(file) {
      // file.url 已经是完整的 URL（在上传成功后已拼接）
      // file.content 是本地预览的 base64 数据
      const imageUrl = file.url || file.content;
      ImagePreview([imageUrl]);
    },

    // 图片超过大小限制
    onImageOversize() {
      this.$toast("图片大小不能超过 5MB");
    },

    // 验证表单
    validateForm() {
      const formListDataLength = this.formListData.length;

      for (let index = 0; index < formListDataLength; index++) {
        const item = this.formListData[index];
        const value = this.formData[item.itemFormKey];

        // 验证必填
        if (item.required) {
          switch (item.questionType) {
            case "single":
            case "blank":
            case "essay":
            case "datetime":
              if (!value || value.trim() === "") {
                this.$toast(`问题${index + 1}为必填项，请填写！`);
                return false;
              }
              break;
            case "multiple":
            case "image":
              if (!value || value.length === 0) {
                this.$toast(
                  `问题${index + 1}为必填项，请${
                    item.questionType === "image" ? "上传图片" : "至少选择一项"
                  }！`
                );
                return false;
              }
              break;
          }
        }

        // 验证"其他"选项的输入（单选和多选）
        const otherValue = this.formData[item.itemFormOtherKey];
        if (
          item.questionType === "single" &&
          value === "OTHER" &&
          !otherValue
        ) {
          this.$toast(`问题${index + 1}，请填写其它内容！`);
          return false;
        }
        if (
          item.questionType === "multiple" &&
          Array.isArray(value) &&
          value.includes("OTHER") &&
          !otherValue
        ) {
          this.$toast(`问题${index + 1}，请填写其它内容！`);
          return false;
        }
      }

      return true;
    },

    // 提交表单
    handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.btnLoading = true;
      const params = { ...this.formData };
      const formListDataLength = this.formListData.length;

      // 处理提交数据 - 按照新的数据结构
      const submitAnswers = [];

      for (let index = 0; index < formListDataLength; index++) {
        const item = this.formListData[index];
        const element = params[item.itemFormKey];
        const otherElement = params[item.itemFormOtherKey];

        // 构建问题数据（包含问题的完整信息）
        let questionData = {
          id: item.id,
          surveyId: parseInt(this.surveyId) || 0,
          content: item.content,
          questionsType: item.questionsType,
          mandatory: item.mandatory || 0,
          questionsOrder: item.questionsOrder || index,
          options: [],
          answerContent: ""
        };

        switch (item.questionType) {
          case "single":
          case "multiple": {
            // 单选/多选题 - 在 options 数组中填充选中的选项
            const formListDataOptions = item.options || [];
            const selectedOptions = [];

            if (Array.isArray(element)) {
              // 多选
              element.forEach((optionNum) => {
                const option = formListDataOptions.find(
                  (opt) => opt.optionNum === optionNum
                );
                if (option) {
                  selectedOptions.push({
                    id: option.id,
                    questionId: item.id,
                    optionNum: option.optionNum,
                    content: option.content,
                    optionOrder: option.optionOrder || 0,
                    otherOption: optionNum === "OTHER" && otherElement ? otherElement : ""
                  });
                }
              });
            } else {
              // 单选
              const option = formListDataOptions.find(
                (opt) => opt.optionNum === element
              );
              if (option) {
                selectedOptions.push({
                  id: option.id,
                  questionId: item.id,
                  optionNum: option.optionNum,
                  content: option.content,
                  optionOrder: option.optionOrder || 0,
                  otherOption: element === "OTHER" && otherElement ? otherElement : ""
                });
              }
            }

            questionData.options = selectedOptions;
            break;
          }

          case "essay":
          case "blank":
          case "datetime":
            // 文本类题目 - 直接填充 answerContent
            questionData.answerContent = element || "";
            break;

          case "image": {
            // 图片题 - answerContent 为逗号分隔的路径字符串
            const imagePaths = element.map((file) =>
              file.serverPath || file.url || file.content
            );
            questionData.answerContent = imagePaths.join(",");
            break;
          }
        }

        submitAnswers.push(questionData);
      }
      console.log("提交的答案数据：", submitAnswers);
      // 提交给父组件
      this.$emit("submit",submitAnswers);

      setTimeout(() => {
        this.btnLoading = false;
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.survey-form {
  padding: 0 18px 12px 18px;
  background-color: #fff;

  .survey-form-box {
    .form-question {
      padding: 16px 0;
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }

      .question-title {
        display: flex;
        align-items: flex-start;
        margin-bottom: 12px;
        font-size: 15px;
        line-height: 1.5;

        .question-number {
          flex-shrink: 0;
          font-weight: 500;
        }

        .question-content {
          flex: 1;
          font-weight: 500;
        }

        .required-mark {
          flex-shrink: 0;
          color: #ee0a24;
          margin-left: 4px;
        }

        .question-type-tag {
          flex-shrink: 0;
          margin-left: 8px;
          padding: 2px 8px;
          font-size: 12px;
          color: #017a3f;
          background-color: #f0f9ff;
          border-radius: 4px;
        }
      }

      .radio-item,
      .checkbox-item {
        margin-bottom: 8px;
      }

      .other-input,
      .essay-input,
      .blank-input,
      .datetime-input {
        margin-top: 8px;
      }

      .other-input,
      .essay-input {
        padding: 8px 12px;
        background-color: #f8f8f8;
        border-radius: 4px;
      }

      .image-uploader {
        margin-top: 8px;

        .preview-cover {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(0, 0, 0, 0.3);

          .van-icon {
            margin: 0 4px;
            color: #fff;
            font-size: 20px;
          }
        }
      }

      .upload-tip {
        margin-top: 8px;
        font-size: 12px;
        color: #999;
      }
    }
  }

  .btn-box {
    padding: 18px 0;
  }
}
</style>
